<template>
    <div class="user_list_page">
      <pageTitle v-bind="{ ...pT }" />
      <business-group :tableConfig="{ ...tableConfig }" :formConfig="{ ...formConfig }"  ref="businessGroup">
        <template slot="formSlot" slot-scope="formSlot">
          <a-form-item>
            <a-input
              placeholder="请输入设备id"
              v-decorator="['deviceId']"
              style="width: 200px; margin-right: 10px; vertical-align: middle"
            />
          </a-form-item>
          <a-form-item>
            <a-input
              placeholder="请输入设备名"
              v-decorator="['userName']"
              style="width: 200px; margin-right: 10px; vertical-align: middle"
            />
          </a-form-item>
        </template>
        <template slot="formRight">
          <a-button type="primary" @click="showForm">新增</a-button>
        </template>
      </business-group>
      <a-modal title="注册设备" destroyOnClose :visible="visible" :maskClosable="false" @ok="register" @cancel="() => visible = false">
        <a-form-model :modal="deviceAuthForm" class="info" layout="vertical" :label-col="labelCol"
                      :wrapper-col="wrapperCol">
          <a-form-model-item label="mac地址:">
            <a-input placeholder="请输入mac地址" v-model="deviceAuthForm.macAddress"  showCount :maxlength="64" />
          </a-form-model-item>
          <a-form-model-item label="选择设备类型:">
            <a-select
              placeholder="请选择更新设备类型"
              v-decorator="['deviceModels']"
              style="width: 150px"
              v-model="deviceAuthForm.deviceModel"
            >
              <a-select-option v-for="el in deviceModels" :value="el.deviceModel" :key="el.id">{{
                el.modelName
              }}</a-select-option>
            </a-select>
          </a-form-model-item>
        </a-form-model>
      </a-modal>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import pageTitle from "@/components/business/pageTitle";
  import businessGroup from "@/components/business/businessGroup";
  import formTime from "@/components/business/Form/formTime";
  import { deviceType } from "@/utils/pageMaps";
  import { tips } from "@/utils/util";
  
  export default {
    created(){
        this.getDeviceModels();
    },
    components: {
      pageTitle,
      businessGroup,
      formTime,
    },
    data() {
      return {
        deviceModels:[],
        deviceType,
        pT: {
          pageTitle: "注册设备",
          // headerTitle: '绑定时间',
          // text: '(单次操作不超过1年)',
        },
        tableConfig: {
          url: "bluetoothlight/web/router/neewerhome/manage/device/auth/get",
          columns: [
            {
              title: "设备id",
              dataIndex: "deviceId",
              key: "deviceId",
              align: "center",
            },
            {
              title: "用户名",
              dataIndex: "userName",
              key: "userName",
              align: "center"
            },
            {
              title: "项目编号",
              dataIndex: "projectNo",
              key: "projectNo",
              align: "center"
            }
          ],
          rowKey: "deviceId",
        },
        formConfig: {
          timeShow: false,
          formShow: true,
        },
        visible:false,
        labelCol: { span: 8 },
        wrapperCol: { span: 15 },
        deviceAuthForm:{
          macAddress:"",
          deviceModel:""
        },
      };
    },
    methods: {
      moment,
      showForm: function(){
        this.deviceAuthForm = {
          macAddress:"",
          deviceModel:""
        };
        this.visible = true;
      },
      register:async function() {
        let url = "bluetoothlight/web/router/neewerhome/manage/device/auth/register";
        const res = await this.$post(url,this.deviceAuthForm);
        const resultStatus = res?.resultStatus;
          if (resultStatus) {
            tips(this, true);
          }
          this.refreshData();
          this.visible = false
      },
      getDeviceModels: async function(){
        let url = "bluetoothlight/web/router/neewerhome/manage/device/classification/get";
        const res = await this.$get(url);
        this.deviceModels = res?.resultData || [];
      },
      refreshData() {
        console.log(this.$refs);
        this.$refs?.["businessGroup"]?.getData?.();
      }
    }
  };
  </script>
  
  
  <style lang="less" scoped>
  .user_list_page {
    .list_button {
      width: 80px;
      height: 30px;
      line-height: 30px;
      text-align: center;
      border: none;
      color: #fff;
      font-size: 12px;
      border-radius: 5px;
      margin-right: 10px;
    }
  }
  </style>
  